/**
 * Generic CSV export utility
 * Works in the browser — no server required
 */

/** Convert an array of objects to a CSV string */
function toCsvString(rows: Record<string, unknown>[], headers: { key: string; label: string }[]): string {
  const escape = (v: unknown): string => {
    const str = v == null ? '' : String(v);
    // Wrap in quotes if it contains comma, newline or double-quote
    if (str.includes(',') || str.includes('\n') || str.includes('"')) {
      return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
  };

  const headerRow = headers.map((h) => escape(h.label)).join(',');
  const dataRows = rows.map((row) =>
    headers.map((h) => escape(row[h.key])).join(',')
  );
  return [headerRow, ...dataRows].join('\r\n');
}

/** Trigger a CSV file download in the browser */
export function downloadCsv(
  rows: Record<string, unknown>[],
  headers: { key: string; label: string }[],
  filename: string
): void {
  const csv = toCsvString(rows, headers);
  // BOM for Excel to recognise UTF-8
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
